<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div class="header-titles">
      <h2 class="modal-title">{{this.isBulkCreate ? 'Bulk Add Inventory' : 'Create Inventory'}}</h2>
      <div class="modal-subtitle">
        {{this.isBulkCreate ? 'Print a batch of tags that share one location and item list' : 'Create a handling unit and add the items it holds'}}
      </div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close(null)">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">

    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faBox" class="section-icon"></fa-icon>
        <h3>Handling Unit</h3>
      </div>
      <div class="section-grid cols-4">
        <mat-form-field *ngIf="!this.isBulkCreate" class="span-2">
          <mat-label>Barcode</mat-label>
          <input [(ngModel)]="this.newHum.barcode" matInput type="text" #barcodeInput id="barcodeInput" name="barcodeInput">
          <button *ngIf="this.newHum.barcode" matSuffix mat-icon-button aria-label="Clear" type="button"
            (click)="this.newHum.barcode = null">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
        </mat-form-field>

        <printer-selector *ngIf="this.isBulkCreate" (selectionChanged)="setPrinter($event)" required></printer-selector>

        <mat-form-field *ngIf="this.isBulkCreate">
          <mat-label># of Tags</mat-label>
          <input [(ngModel)]="this.tagQty" matInput type="text" #tagQtyInput id="tagQtyInput" name="tagQtyInput">
        </mat-form-field>

        <mat-form-field>
          <mat-label>Status</mat-label>
          <mat-select id="status" [(ngModel)]="this.newHum.inventoryStatusId" name="status" #status="ngModel">
            <mat-option *ngFor="let status of this.allStatuses" [value]="status.id">
              {{status.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>

    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faLocationDot" class="section-icon"></fa-icon>
        <h3>Location</h3>
        <div class="section-actions">
          <button mat-stroked-button type="button" (click)="scan()">
            <fa-icon [icon]="faScanner" class="me-2"></fa-icon>Scan Location
          </button>
        </div>
      </div>
      <div class="section-grid cols-3">
        <mat-form-field>
          <mat-label>{{"Warehouse" | tenantWords}}</mat-label>
          <mat-select id="warehouseSelect" required [(ngModel)]="this.newHum.warehouseId" name="warehouseSelect"
            #warehouseSelect="ngModel" (ngModelChange)="warehouseSelectionChanged()">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="this.searchWarehouse" (ngModelChange)="filterWarehouses()"
                placeholderLabel="Find warehouse." noEntriesFoundLabel="No warehouse found" name="warehouseSearch"
                #warehouseSearch="ngModel">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="this.filteredWarehouseOptions.length === 0">
              {{this.warehouseSearchPrompt}}
            </mat-option>
            <mat-option *ngFor="let warehouse of this.filteredWarehouseOptions" [value]="warehouse.id">
              {{warehouse.name}}
            </mat-option>
          </mat-select>
          <mat-error>{{"Warehouse" | tenantWords}} is required</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"Room" | tenantWords}}</mat-label>
          <mat-select id="roomSelect" required [(ngModel)]="this.newHum.roomId" name="roomSelect"
            #roomSelect="ngModel" (ngModelChange)="roomSelectionChanged()">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="this.searchRoom" (ngModelChange)="filterRooms()"
                placeholderLabel="Find room." noEntriesFoundLabel="No room found" name="roomSearch"
                #roomSearch="ngModel">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="this.filteredRoomOptions.length === 0">
              {{this.roomSearchPrompt}}
            </mat-option>
            <mat-option *ngFor="let room of this.filteredRoomOptions" [value]="room.id">
              {{room.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"Location" | tenantWords}}</mat-label>
          <mat-select id="locationSelect" required [(ngModel)]="this.newHum.roomLocationId" name="locationSelect"
            #locationSelect="ngModel" (ngModelChange)="locationSelectionChanged()">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="this.searchLocation" (ngModelChange)="filterLocations()"
                placeholderLabel="Find location." noEntriesFoundLabel="No locations found" name="locationSearch"
                #locationSearch="ngModel">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="this.filteredLocationOptions.length === 0">
              {{this.locationSearchPrompt}}
            </mat-option>
            <mat-option *ngFor="let loc of this.filteredLocationOptions" [value]="loc.id">
              {{loc.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>

    <section class="form-section" *ngIf="isREPToken">
      <div class="section-head">
        <fa-icon [icon]="faFileLines" class="section-icon"></fa-icon>
        <h3>Purchase Order</h3>
      </div>
      <div class="section-grid cols-4">
        <mat-form-field appearance="outline">
          <mat-label>Vendor</mat-label>
          <mat-select id="vendor" [(ngModel)]="newHum.vendorId" name="vendor" #vendor="ngModel"
            (ngModelChange)="searchItemsabySelectedVendor()" (keyup.enter)="searchItemsabySelectedVendor()">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="searchVendor" (ngModelChange)="filterVendor()"
                placeholderLabel="Find Vendor." noEntriesFoundLabel="No Vendor found" name="vendorSearch"
                #vendorSearch="ngModel">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="VendorList.length === 0">
              {{VendorPrompt}}
            </mat-option>
            <mat-option *ngFor="let item of VendorList" [value]="item.id">
              {{item.contactName}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Variety</mat-label>
          <mat-select id="variety" [(ngModel)]="newHum.varietyId" name="variety" #variety="ngModel"
            (ngModelChange)="searchItemsabySelectedVariety()" (keyup.enter)="searchItemsabySelectedVariety()">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="searchVariety" (ngModelChange)="filterVariety()"
                placeholderLabel="Find Variety." noEntriesFoundLabel="No Variety found" name="varietySearch"
                #varietySearch="ngModel">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="VarietyList.length === 0">
              {{VarietyPrompt}}
            </mat-option>
            <mat-option *ngFor="let item of VarietyList" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Crop Year</mat-label>
          <mat-select id="cropYear" [(ngModel)]="newHum.cropYearId" name="cropYear" #cropYear="ngModel"
            (ngModelChange)="searchItemsabySelectedCropYear()" (keyup.enter)="searchItemsabySelectedCropYear()">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="searchCropYear" (ngModelChange)="filterCropYear($event)"
                placeholderLabel="Find CropYear." noEntriesFoundLabel="No CropYear found" name="cropYearSearch"
                #cropYearSearch="ngModel" [maxlength]="4">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="cropYearList.length === 0">
              {{CropYearPrompt}}
            </mat-option>
            <mat-option *ngFor="let item of cropYearList" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Purchase Order</mat-label>
          <mat-select id="po" [(ngModel)]="newHum.purchaseOrderId" name="po" #po="ngModel"
            (ngModelChange)="searchItemsabySelectedPO()" (keyup.enter)="searchItemsabySelectedPO()">
            <mat-option>
              <ngx-mat-select-search [(ngModel)]="searchPO" (ngModelChange)="filterPO()"
                placeholderLabel="Find purchase order." noEntriesFoundLabel="No purchase order found" name="poSearch"
                #poSearch="ngModel">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngIf="filteredSearchOptions.length === 0">
              {{poSearchPrompt}}
            </mat-option>
            <mat-option *ngFor="let item of filteredSearchOptions" [value]="item.id">
              {{item.offerNo}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>

    <div class="items-row">
      <inventory-add-item-popup #addItemPopup name="addItemPopup" id="addItemPopup" [isHumEdit]="true" [hum]="this.newHum"
        [isBulkCreate]="this.isBulkCreate" [items]="items"></inventory-add-item-popup>
      <inventory-adjust-qty-popup [isHumEdit]="true" [hum]="this.newHum"></inventory-adjust-qty-popup>
    </div>

  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="close(null)">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="submit()">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
    </button>
  </div>

</div>
